var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoStyleSpy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A9D6E5",
    d: "M0 10C0 4.477 4.477 0 10 0h40c5.523 0 10 4.477 10 10v40c0 5.523-4.477 10-10 10H10C4.477 60 0 55.523 0 50V10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "M19.32 19.197C20.633 17.788 22.502 17 24.71 17h11.246c2.212 0 4.082.788 5.394 2.197 1.305 1.4 1.983 3.335 1.983 5.505v10.596c0 2.17-.678 4.104-1.983 5.505C40.038 42.213 38.167 43 35.955 43H24.71c-2.213 0-4.083-.788-5.395-2.197-1.304-1.401-1.982-3.335-1.982-5.505V24.702c0-2.171.682-4.105 1.987-5.506Zm1.463 1.363c-.903.969-1.45 2.386-1.45 4.142v10.596c0 1.757.545 3.174 1.446 4.142.894.96 2.212 1.56 3.93 1.56h11.246c1.718 0 3.038-.6 3.932-1.56.901-.968 1.446-2.385 1.446-4.142V24.702c0-1.757-.545-3.174-1.446-4.142-.894-.96-2.213-1.56-3.931-1.56H24.709c-1.711 0-3.03.6-3.926 1.56Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "M23.685 24.188a1 1 0 0 1 1-1h2.644a1 1 0 1 1 0 2h-1.644v9.631h1.644a1 1 0 1 1 0 2h-2.644a1 1 0 0 1-1-1V24.187ZM32.339 24.188a1 1 0 0 1 1-1h2.644a1 1 0 0 1 1 1v11.631a1 1 0 0 1-1 1h-2.644a1 1 0 0 1 0-2h1.644v-9.632h-1.644a1 1 0 0 1-1-1Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStyleSpy);
export default __webpack_public_path__ + "static/media/logo-style-spy.9422f4e4b4ea5b34b4c68911664647b9.svg";
export { ForwardRef as ReactComponent };